import {Routes} from '@angular/router';
import {checkTutorialGuard} from './core/guards/check-tutorial.guard';
import {isAuthenticatedGuard} from './core/guards/is-authenticated.guard';

export const routes: Routes = [
  {
    path: '',
    // redirectTo: '/tabs/repartos',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/login/login').then((m) => m.LoginPage),
    canActivate: [isAuthenticatedGuard]
  },
  {
    path: 'tabs',
    loadChildren: () =>
      import('./core/layout/tabs-page/routes').then((m) => m.TABS_ROUTES),
    canActivate: [isAuthenticatedGuard]
  },
  {
    path: 'tutorial',
    loadComponent: () =>
      import('./pages/tutorial/tutorial').then((m) => m.TutorialPage),
    canMatch: [checkTutorialGuard]
  },
  {
    path: '**',
    // redirectTo: '/tabs/repartos',
    redirectTo: '/login',
    pathMatch: 'full'
  }
];
